import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8438a29e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438a29e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8438a29e')) {
      api.createRecord('8438a29e', component.options)
    } else {
      api.reload('8438a29e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8438a29e&scoped=true&", function () {
      api.rerender('8438a29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HJMsOZtSTc2m/JS/comp/SearchFilterTokens.vue"
export default component.exports